import React, { useEffect, useRef } from 'react';
import { useDashboardData } from '../context/DashboardDataContext';
import { useActiveDashboard } from '../context/ActiveDashboardContext';
import SolmanDashboardComponent from '../dashboards/SolmanDashboard';

export default function SolmanDashboardPage() {
  const { publishData } = useDashboardData();
  const activeKey       = useActiveDashboard();
  const lastData        = useRef(null);

  // Re-publish saat dashboard ini kembali aktif
  useEffect(() => {
    if (activeKey === 'solman' && lastData.current) {
      publishData(lastData.current);
    }
  }, [activeKey]); // eslint-disable-line

  const handleDataChange = ({ filtered, stats, data, filters }) => {
    if (!stats || !filtered || filtered.length === 0) return;

    const payload = {
      type: 'solman',
      filtered, stats, data, filters,
      updatedAt: new Date().toISOString(),
    };

    lastData.current = payload;
    publishData(payload);
  };

  return <SolmanDashboardComponent onDataChange={handleDataChange} />;
}
